export default __webpack_public_path__ + "static/media/loft02.cd956b9b.jpg";